export default __webpack_public_path__ + "static/media/04.9e5a6a37.png";